<script>
import GameNavigationBottom from '@/components/meta/GameNavigationBottom'
import GameNavigationTop from '@/components/meta/GameNavigationTop'
import ChannelChange from '@/components/transitions/ChannelChange.vue'

import events from '@/services/events'
import notifications from '@/services/notifications'

export default {
  name: 'ViewGame',

  components: {
    ChannelChange,
    GameNavigationBottom,
    GameNavigationTop
  },

  computed: {

    notifications () {
      return notifications.stack
    }

  },

  mounted () {
    events.$on('inventoryItem:created', this.onInventoryItemCreate)
    events.$on('inventoryItem:deleted', this.onInventoryItemDelete)
  },

  beforeDestroy () {
    events.$off('inventoryItem:created', this.onInventoryItemCreate)
    events.$off('inventoryItem:deleted', this.onInventoryItemDelete)
  },

  methods: {

    onInventoryItemCreate (inventoryItem) {
      notifications.open(inventoryItem.name + ' added to inventory')
    },

    onInventoryItemDelete (inventoryItem) {
      notifications.open(inventoryItem.name + ' removed from inventory')
    }

  }
}
</script>

<template>
  <div class="c-view-game">
    <div class="c-view-game-content">

      <div
        v-if="notifications.length"
        class="c-view-game-notifications"
      >
        <div class="c-view-game-notifications">
          <div
            v-for="notification in notifications"
            :key="notification.id"
            class="c-view-game-notification"
          >
            {{ notification.message }}
          </div>
        </div>
      </div>

      <game-navigation-top class="c-view-game-navigation-top" />

      <div class="c-view-game-center">
        <div class="c-view-game-center-content">
          <channel-change>
            <router-view :key="$route.name" />
          </channel-change>
        </div>
      </div>

      <game-navigation-bottom class="c-view-game-navigation-bottom" />

    </div>
  </div>
</template>

<style lang="scss">

.c-view-game {
  @include fill-relative;
}

.c-view-game-content {
  @include fill-relative;
  @include flex;
  @include flex-vertical;
}

// Notifications

.c-view-game-notifications {
  @include fixed;
  top: 4rem;
  right: 3rem;
  z-index: 7;
  max-width: 30%;
}

.c-view-game-notifications-content {
  @include grid;
  @include grid-gap($pad-horizontal, $pad-horizontal);
}

.c-view-game-notification {
  @include align-right;
  font-size: 2rem;
  color: $green;
  background-color: translucent($very-dark, 0.2);

  animation-name: screen-text-glow-green;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}

// Screen elements

.c-view-game-navigation-top,
.c-view-game-navigation-bottom,
.c-view-game-center {
  @include border-box;
}

.c-view-game-navigation-top,
.c-view-game-navigation-bottom {
  @include relative;
  @include flex-fixed;
  @include buffer-loose-horizontal;
  z-index: 2;
}

.c-view-game-center {
  @include relative;
  @include flex-fluid;
  @include scroll;
  z-index: 1;
  // -webkit-overflow-scrolling: touch;
}

.c-view-game-center-content {
  @include fill-relative;
  @include buffer-vertical-even;
  @include buffer-loose-horizontal;
}

.c-view-game {

  .c-game-navigation-top-content,
  .c-game-navigation-bottom-content {
    @include keep-center;
    @include limit-content-loose;
  }

  .c-game-navigation-top-content {
    padding-top: $pad-loose-horizontal;
  }

  .c-game-navigation-bottom-content {
    padding-bottom: $pad-loose-horizontal;
  }

}

.c-view-game-navigation-top {
  box-shadow: 0 0.1rem 0 0 translucent($default-text-color, 0.2);
}

.c-view-game-navigation-bottom {
  box-shadow: 0 -0.1rem 0 0 translucent($default-text-color, 0.2);
}

</style>
